import { createContext } from 'react';

/** A stepper supplies a host; the companion retains ownership of its single toggle. */
export const WorkflowAssistantHeaderContext = createContext<{
  registerSlot(slot: HTMLElement): () => void;
} | null>(null);
